a.s.userpicker = (function(){
	var my = {
		pick:function(cb,o){
			var multiple = o.multiple || false;
			var filter = o.filter || {};
			tpl.run({tpl:'/tpl/shared/userpicker/main.ejs?v='+v,data:{
				multiple:multiple
			},cb:function(content){
				var token = a.popup.create({
					title:'Select user',
					width:600,
					height:500,
					show_actions:multiple,
					btntitle:'Select (0)',
					content:content,
					add_cancel: true,
					submit:function(){
						// Rebound in search result
					},
					close:function(){
						
					},
					ready:function(token){
						var win = $('#popupid_'+token);
						if (multiple) {
							// Disable submit button
							$('button[data-btn="btn_submit"]',win).prop('disabled',true);
						}
						if (filter.q) {
							$('input[name="q"]',win).val(filter.q);
						}
						// Focus search
						$('input[name="q"]',win).focus();
						$('input[name="q"]',win).unbind('keyup').keyup(function(){
							my.search(win,token,$('input[name="q"]',win).val(),cb);
						});
						// Initial search
						my.search(win,token,$('input[name="q"]',win).val(),filter,multiple,cb);
					}
				});
			}});
		},
		search:debounce(function(win,token,q,filter,multiple,cb){
			filter.q = q;
			filter.token = localStorage.getItem('token');
			filter.accountname = localStorage.getItem('accountname');
			$('button[data-btn="btn_submit"]',win).prop('disabled',true).text('Select (0)');
			my.loader.add(win);
			if (multiple) {
				var tpl_name = 'list_multiple.ejs?v='+v;
			}
			else {
				var tpl_name = 'list.ejs?v='+v;
			}
			$.ajax({
				type:'GET',
				url:'/api/account/user/list/',
				data:filter,
				dataType:'json',
				cache: false,
				success:function(result) {
					if (typeof(result.list)!=='undefined') {
						tpl.run({tpl:'/tpl/shared/userpicker/'+tpl_name,data:result,cb:function(content){
							$('div[data-area="result"]',win).empty().append(content);
							if (multiple) {
								// Bind cb change
								$('input[name="userlist[]"]',win).unbind('change').change(function(){
									if ($('input[name="userlist[]"]:checked',win).length>0) {
										$('button[data-btn="btn_submit"]',win).prop('disabled',false).text('Select ('+$('input[name="userlist[]"]:checked',win).length+')');
									}
									else {
										$('button[data-btn="btn_submit"]',win).prop('disabled',true).text('Select (0)');
									}
								});
								// Bind submit button
								$('button[data-btn="btn_submit"]',win).unbind('click').click(function(){
									var outputlist = [];
									var c = 0;
									$('input[name="userlist[]"]:checked',win).each(function(){
										c++;
										if (result.list[$(this).parent().parent().attr('data-index')].id==$(this).parent().parent().attr('data-iid')) {
											outputlist.push(result.list[$(this).parent().parent().attr('data-index')]);
											if ($('input[name="userlist[]"]:checked',win).length==c) {
												// Return result
												cb(outputlist);
												// Close window
												window.history.back();
											}
										}
									});
								});
							}
							else {
								// Bind click callback
								$('div[data-area="result"] table tr',win).unbind('click').click(function(){
									if (result.list[$(this).attr('data-index')].id==$(this).attr('data-iid')) {
										// Return result
										cb(result.list[$(this).attr('data-index')]);
										// Close window
										window.history.back();
									}
									else {
										a.s.growl.create('Error','Unable to find correct user, please reload and try again',{});
									}
								});
							}
						}});
					}
					else {
						tpl.run({tpl:'/tpl/shared/userpicker/nohits.ejs?v='+v,data:result,cb:function(content){
							$('div[data-area="result"]',win).empty().append(content);
						}});
					}
				}
			});
		},250),
		loader:{
			add:function(win){
				$('div[data-area="result"]',win).empty().append('<i class="loader fa fa-spin fa-sync" style="font-size:36px;color:#ddd;margin:3em 0;"></i>');
			},
			remove:function(win){
				$('div[data-area="result"] .loader',win).remove();
			}
		}
	}
	return my;
}());